import {
  find,
  filter,
  slice,
  some,
  orderBy,
  groupBy,
} from 'lodash';
import { isRoomOnline } from 'shared/helpers';

export const checkRoomAnswers = room => isRoomOnline(room.roomType) ? false : (+room.answerDocScored) + (+room.answerDocVoided) !== (+room.examineeCount);

// export const checkUsedMaterials = materialsRanges => some(materialsRanges, ranges => ranges && some(ranges, range => (+range.usedCount) + (+range.unusedCount) !== (+range.count)));

export const checkUsedMaterials = (materialsRanges) => {
  const errors = [];

  materialsRanges.map((ranges, materialTypeId) => {
    ranges && ranges.map((range, index) => {
      if (!isNaN(range.usedCount) && !isNaN(range.unusedCount) && (+range.usedCount) + (+range.unusedCount) !== (+range.count)) {
        errors.push({
          materialTypeId,
          index,
          rangeUsedUnused: 'testCenter.testMaterialsRanges.error.totalBooklets',
        });
      }
    });
  });

  return errors;
};


export const checkRangeInterval = (materialsRanges) => {
  const errors = [];

  materialsRanges.map((ranges, materialTypeId) => {
    ranges && ranges.map((range, index) => {
      if (range.rangeBegin && range.rangeEnd && range.rangeBegin > range.rangeEnd) {
        errors.push({
          materialTypeId,
          index,
          message: 'testCenter.testMaterialsRanges.error.rangeInterval',
        });
      }
    });
  });

  return errors;
};

export const checkRangeOverlap = (materialsRanges) => {
  const errors = [];

  materialsRanges.map((ranges, materialTypeId) => {
    ranges && ranges.map((range, index) => {
      if (index > 0) {
        if ((range.rangeBegin || range.rangeEnd) && find(slice(ranges, 0, index), r => (+range.rangeBegin >= +r.rangeBegin && +range.rangeBegin <= +r.rangeEnd)
          || (+range.rangeEnd >= +r.rangeBegin && +range.rangeEnd <= +r.rangeEnd)
          || (+range.rangeBegin <= +r.rangeBegin && +range.rangeEnd >= +r.rangeEnd))) {
          errors.push({
            materialTypeId,
            index,
            message: 'testCenter.testMaterialsRanges.error.rangeOverlap',
          });
        }
      }
    });
  });

  return errors;
};

export const checkRoomRangeOverlap = (roomRanges, allRoomsRanges) => {
  const errors = [];

  roomRanges.map((ranges, materialTypeId) => {
    ranges && ranges.map((range, index) => {
      if ((range.rangeBegin || range.rangeEnd) && find(allRoomsRanges, r => range.materialTypeId === r.materialTypeId
          && range.roomId != r.roomId
          && (
            (+range.rangeBegin >= +r.rangeBegin && +range.rangeBegin <= +r.rangeEnd)
            || (+range.rangeEnd >= +r.rangeBegin && +range.rangeEnd <= +r.rangeEnd)
            || (+range.rangeBegin <= +r.rangeBegin && +range.rangeEnd >= +r.rangeEnd)
          ))) {
        errors.push({
          materialTypeId,
          index,
          message: 'testCenter.testMaterialsRanges.error.rangeOverlapRoom',
        });
      }
    });
  });

  return errors;
};

const mergeEventRanges = ranges => {
  const orderedGroup = orderBy(ranges,'rangeBegin');
  let newList = [];
  let last;
  orderedGroup.forEach((el) => {
    if(!last || +el.rangeBegin !== last[1] + 1){
      last=[+el.rangeBegin, +el.rangeEnd];
      newList.push(last);
    } else if(+el.rangeBegin === last[1] + 1){
      last[1] = +el.rangeEnd;
    }
  });

  return newList;
};

export const checkRangeEvent = (roomRanges, allEventRanges) => {
  const errors = [];
  const groupedRangedById = groupBy(allEventRanges, 'materialTypeId');
  Object.keys(groupedRangedById).forEach(key =>
    groupedRangedById[key] = mergeEventRanges(groupedRangedById[key])
  );

  roomRanges.map((ranges, materialTypeId) => {
    ranges && ranges.map((range, index) => {
      if ((range.rangeBegin || range.rangeEnd) && !find(groupedRangedById[materialTypeId],
            r => +range.rangeBegin >= r[0] && +range.rangeEnd <= r[1])) {
        errors.push({
          materialTypeId,
          index,
          message: 'testCenter.testMaterialsRanges.error.notIncludedEventRanges',
        });
      }
    });
  });

  return errors;
};


export const checkEventRangeAssignedToRooms = (eventRanges, allRoomsRanges) => {
  const errors = [];

  // check if there are rooms with ranges that are not included into event materialType ranges
  if (allRoomsRanges.map((rangeRoom) => {
    if (!some(mergeEventRanges(eventRanges[rangeRoom.materialTypeId]), range => (range[0] <= +rangeRoom.rangeBegin && range[1] >= +rangeRoom.rangeEnd))) {
      // check if error exist for materialTypeId
      if (!find(errors, { materialTypeId: rangeRoom.materialTypeId })) {
        errors.push({
          materialTypeId: rangeRoom.materialTypeId,
          type: 'materialType',
          message: 'testCenter.testMaterialsRanges.error.eventRangeAssignedToRooms',
        });
      }
    }
  })
  ) return errors;
};

export const checkTotalCount = materialsRanges => {
  const errors = [];

  materialsRanges.map((ranges, materialTypeId) => {
    ranges && ranges.map((range, index) => {
      if ((range.rangeBegin && range.rangeEnd && range.count) && range.rangeBegin <= range.rangeEnd &&
        ((+range.rangeEnd) - (+range.rangeBegin) + 1 !== (+range.count))) {
        errors.push({
          materialTypeId,
          index,
          totalCount: 'testCenter.testMaterialsRanges.error.mismatchTotalCount',
          message: 'testCenter.testMaterialsRanges.error.mismatchTotalCount',
        });
      }
    });
  });

  return errors;
};

